import { render, staticRenderFns } from "./moreInfo.vue?vue&type=template&id=0c0aa698&scoped=true"
import script from "./moreInfo.vue?vue&type=script&lang=js"
export * from "./moreInfo.vue?vue&type=script&lang=js"
import style0 from "./moreInfo.vue?vue&type=style&index=0&id=0c0aa698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0aa698",
  null
  
)

export default component.exports